import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const Pagination = ({
  itemsPerPage,
  startIndex,
  setStartIndex,
  endIndex,
  setEndIndex,
  len,
}) => {
  const handleNext = () => {
    setStartIndex((prev) => prev + itemsPerPage);
    setEndIndex((prev) => prev + itemsPerPage);
  };

  const handlePrevious = () => {
    setStartIndex((prev) => prev - itemsPerPage);
    setEndIndex((prev) => prev - itemsPerPage);
  };
  return (
    <div className="flex items-center justify-center gap-10">
      {startIndex !== 0 ? (
        <button
          onClick={handlePrevious}
          className="flex flex-row items-center justify-center gap-2 py-1 pl-2 pr-3"
        >
          <FaAngleLeft />
          <span>Prev</span>
        </button>
      ) : null}
      {endIndex < len ? (
        <button
          onClick={handleNext}
          className="flex flex-row items-center justify-center gap-2 bg-secondary py-1 pl-3 pr-2 text-primary rounded-sm"
        >
          <span>Next</span>
          <FaAngleRight />
        </button>
      ) : null}
    </div>
  );
};

export default Pagination;
